/* Łapka.pl: galeria, wybór zestawu, pasek na telefonie, karuzela opinii. Bez bibliotek. */
(function () {
  'use strict';
  if (window.__lpJs) return; window.__lpJs = true; /* skrypt dołącza kilka sekcji, ma się wykonać raz */

  function money(cents) {
    var zl = (cents / 100).toFixed(2).replace('.', ',');
    return zl.replace(/,00$/, '') + ' zł';
  }

  /* ---- galeria ---- */
  document.querySelectorAll('[data-lp-galeria]').forEach(function (g) {
    var slajdy = g.querySelectorAll('.lp-galeria__slajd');
    var miniatury = g.querySelectorAll('.lp-galeria__min');
    var i = 0;
    function pokaz(n) {
      i = (n + slajdy.length) % slajdy.length;
      slajdy.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      miniatury.forEach(function (m, k) {
        m.classList.toggle('is-active', k === i);
        if (k === i && m.scrollIntoView) m.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
    }
    miniatury.forEach(function (m, k) { m.addEventListener('click', function () { pokaz(k); }); });
    g.querySelector('.lp-galeria__strzalka--l') && g.querySelector('.lp-galeria__strzalka--l').addEventListener('click', function () { pokaz(i - 1); });
    g.querySelector('.lp-galeria__strzalka--p') && g.querySelector('.lp-galeria__strzalka--p').addEventListener('click', function () { pokaz(i + 1); });
    /* przesunięcie palcem */
    var x0 = null;
    g.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    g.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) pokaz(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
    g.pokaz = pokaz;
  });

  /* ---- wybór zestawu ---- */
  document.querySelectorAll('[data-lp-kupno]').forEach(function (box) {
    var form = box.querySelector('form[action*="/cart/add"]');
    var idInput = form && form.querySelector('input[name="id"]');
    var karty = box.querySelectorAll('.lp-zestaw');
    var cenaTeraz = box.querySelector('[data-lp-cena]');
    var cenaPrzed = box.querySelector('[data-lp-cena-przed]');
    var oszcz = box.querySelector('[data-lp-oszcz]');
    var oszczBox = box.querySelector('[data-lp-oszcz-box]');
    var oszczKwota = box.querySelector('[data-lp-oszcz-kwota]');
    var sticky = document.querySelector('[data-lp-sticky-cena]');
    var galeria = document.querySelector('[data-lp-galeria]');

    function wybierz(karta, push) {
      karty.forEach(function (k) { k.classList.toggle('is-active', k === karta); });
      var r = karta.querySelector('input[type="radio"]'); if (r) r.checked = true;
      var id = karta.dataset.wariant, cena = parseInt(karta.dataset.cena, 10), przed = parseInt(karta.dataset.przed || '0', 10);
      if (idInput) idInput.value = id;
      if (cenaTeraz) cenaTeraz.textContent = money(cena);
      if (cenaPrzed) cenaPrzed.textContent = przed > cena ? money(przed) : '';
      if (oszcz) oszcz.textContent = przed > cena ? ('Oszczędzasz ' + Math.round((1 - cena / przed) * 100) + '%') : '';
      if (oszczBox) {
        if (przed > cena) { oszczBox.hidden = false; if (oszczKwota) oszczKwota.textContent = money(przed - cena); }
        else oszczBox.hidden = true;
      }
      if (sticky) sticky.innerHTML = money(cena) + (przed > cena ? '<s>' + money(przed) + '</s>' : '');
      /* zdjęcie wariantu pokazujemy po kliknięciu, nie przy wejściu: na starcie ma być pierwsze zdjęcie (hero) */
      if (push && galeria && karta.dataset.obraz !== undefined && karta.dataset.obraz !== '' && galeria.pokaz) galeria.pokaz(parseInt(karta.dataset.obraz, 10));
      if (push && window.history && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', id); window.history.replaceState({}, '', u);
      }
    }
    karty.forEach(function (k) { k.addEventListener('click', function () { wybierz(k, true); }); });
    var zUrl = new URL(window.location.href).searchParams.get('variant');
    var start = null;
    karty.forEach(function (k) { if (zUrl && k.dataset.wariant === zUrl) start = k; });
    if (!start) karty.forEach(function (k) { if (!start && k.dataset.domyslny === 'true') start = k; });
    if (!start && karty.length) start = karty[0];
    if (start) wybierz(start, false);
  });

  /* ---- pasek na telefonie ---- */
  var pasek = document.querySelector('[data-lp-sticky]');
  var kotwica = document.querySelector('[data-lp-kotwica-atc]');
  if (pasek && kotwica && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      pasek.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
    }).observe(kotwica);
    var btn = pasek.querySelector('button');
    btn && btn.addEventListener('click', function () {
      var f = document.querySelector('[data-lp-kupno] form[action*="/cart/add"]');
      if (!f) return;
      if (f.requestSubmit) f.requestSubmit(); else f.querySelector('[type="submit"]').click();
    });
  }

  /* ---- karuzela opinii ---- */
  document.querySelectorAll('[data-lp-opinie]').forEach(function (s) {
    var tor = s.querySelector('.lp-opinie__tor'); if (!tor) return;
    var krok = function () { var k = tor.querySelector('.lp-opinia'); return k ? k.getBoundingClientRect().width + 20 : 300; };
    var p = s.querySelector('.lp-opinie__btn--wstecz'), n = s.querySelector('.lp-opinie__btn--dalej');
    p && p.addEventListener('click', function () { tor.scrollBy({ left: -krok(), behavior: 'smooth' }); });
    n && n.addEventListener('click', function () { tor.scrollBy({ left: krok(), behavior: 'smooth' }); });
    /* tor ma wysokość najwyższej z kart widocznych w tej chwili, nie najwyższej z wszystkich (te za strzałką robiły pustą przerwę pod opiniami) */
    var karty = Array.prototype.slice.call(tor.querySelectorAll('.lp-opinia'));
    function dopasuj() {
      var r = tor.getBoundingClientRect(), max = 0;
      karty.forEach(function (k) {
        var b = k.getBoundingClientRect();
        if (b.right > r.left + 8 && b.left < r.right - 8 && b.height > max) max = b.height;
      });
      if (!max) return;
      var cs = getComputedStyle(tor);
      tor.style.height = Math.ceil(max + parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom)) + 'px';
    }
    var dt = null, odloz = function () { clearTimeout(dt); dt = setTimeout(dopasuj, 60); };
    dopasuj();
    tor.addEventListener('scroll', odloz, { passive: true });
    window.addEventListener('resize', odloz);
    window.addEventListener('load', dopasuj);
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(odloz); karty.forEach(function (k) { ro.observe(k); }); }
  });

  /* ---- filmiki klientów: dźwięk włącza się w jednym kadrze naraz ---- */
  document.querySelectorAll('[data-lp-wideo]').forEach(function (s) {
    var kadry = s.querySelectorAll('.lp-wideo__kadr');
    kadry.forEach(function (k) {
      var v = k.querySelector('video'), b = k.querySelector('[data-lp-dzwiek]');
      if (!v || !b) return;
      b.addEventListener('click', function () {
        var wlacz = v.muted;
        kadry.forEach(function (inny) { var iv = inny.querySelector('video'); if (iv) { iv.muted = true; } inny.classList.remove('is-glos'); });
        if (wlacz) { v.muted = false; v.currentTime = 0; v.play(); k.classList.add('is-glos'); }
      });
    });
    if ('IntersectionObserver' in window) {  /* poza ekranem pauza, w ekranie gra (oszczędza baterię) */
      var io = new IntersectionObserver(function (wpisy) { wpisy.forEach(function (w) { var v = w.target.querySelector('video'); if (!v) return; if (w.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } }); }, { threshold: 0.25 });
      kadry.forEach(function (k) { io.observe(k); });
    }
  });

  /* ---- zdjęcia klientów: taśma płynie bez przerwy, powoli i w stałym tempie; zapętlona przez sklonowane kadry;
          staje po najechaniu/dotknięciu, rusza dalej po chwili ---- */
  /* Ruch robi animacja CSS (transform na .lp-zdjecia__tor), bez pracy JS w każdej klatce. JS tylko klonuje kadry, liczy szerokości i czas pętli. */
  var bezRuchu = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.lp-zdjecia__tasma').forEach(function (tasma) {
    var kadry = Array.prototype.slice.call(tasma.querySelectorAll('.lp-zdjecia__kadr'));
    if (bezRuchu || kadry.length < 2) return;
    var PX_NA_S = 40, GAP = 16, tor = document.createElement('div'), wznow = null;
    tor.className = 'lp-zdjecia__tor';
    kadry.forEach(function (k) { tor.appendChild(k); });
    kadry.forEach(function (k) { var c = k.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-shopify-editor-block'); tor.appendChild(c); });
    tasma.appendChild(tor);
    tasma.style.scrollSnapType = 'none';
    function wymiary() {
      var szer = Math.round(tasma.clientWidth * (window.innerWidth >= 750 ? 0.34 : 0.72));
      Array.prototype.forEach.call(tor.children, function (k) { k.style.flexBasis = szer + 'px'; });
      var polowa = kadry.length * (szer + GAP);
      tor.style.setProperty('--lp-plyn-czas', (polowa / PX_NA_S).toFixed(1) + 's');
    }
    wymiary();
    var rt = null; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(wymiary, 150); });
    tasma.addEventListener('touchstart', function () { clearTimeout(wznow); tor.classList.add('is-pauza'); }, { passive: true });
    tasma.addEventListener('touchend', function () { clearTimeout(wznow); wznow = setTimeout(function () { tor.classList.remove('is-pauza'); }, 4000); }, { passive: true });
  });
})();
